<template>
    <div class="experiencefragment aem-GridColumn aem-GridColumn--default--12 footer-container">
       <div id="experiencefragment-023c0f094e" class="cmp-experiencefragment cmp-experiencefragment--header">
          <div class="xf-content-height">
             <div class="aem-Grid aem-Grid--12 aem-Grid--default--12">
             <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
                <div class="aem-Grid aem-Grid--12 aem-Grid--default--12">
                <div id="footerContainer" class="footer aem-GridColumn aem-GridColumn--default--12">
                </div>
                </div>
             </div>
          </div>
          </div>
       </div>
    </div>
 </template>
 
 <script>
   import { mapGetters } from 'vuex';

   export default {
    name: "TheFooter",
    computed: {
     ...mapGetters({
         footerHTML: 'footerHTML'
      })
    },
    watch:{
      footerHTML(value) {
         document.getElementById('footerContainer').innerHTML = value;
         let cookieBtnLink = document.querySelectorAll(".mchp-cookie-banner__actions > .mchp-button-wrapper > a")[0];
         if(cookieBtnLink){
         cookieBtnLink.onclick = function() {
            cookieBtnLink.href = window.location.href;
            window.setCookieAgree();
         };
         }
      },
    },
    mounted() {
      this.$store.dispatch('getFooterHTML');
    },
}
 </script>
 <style>
    footer .main .max>div {
        width: 24%;
    }
    .footer-container {
      margin-top: 30px;
    }

     .tooltip.tooltip-top-center{
      opacity: 0.96;
      visibility: visible;
      z-index:100;
      background-color: #333 !important;
      border-color: #333 !important;
       animation: none !important;
      transition: none !important;
      transform: none !important;
      margin-left: -2em ;
    }
   
   .tooltip.tooltip-top-center::after{
      display: none;
   }
 </style>